import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
  HttpErrorResponse ,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceBase } from './ServiceBase';
import { FileUploadRoot } from 'src/model/Project/FileUploadRoot';
import { UploadResp } from 'src/model/Project/UploadResp';

@Injectable({
  providedIn: 'root',
})
export class SyncService extends ServiceBase {
  constructor(http: HttpClient) {
    super(http);
  }

  uploadFile(file: File): Observable<UploadResp> {
    const formData = new FormData();
    formData.append('file', file);
    
    // 將目前的語系加入 FormData 中，提供給後端使用
    const currentLang = localStorage.getItem('app_lang') || 'zh-TW';
    formData.append('lang', currentLang);
    return this.http
      .post(environment.APIPath + '/v1/project/csvListener', formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        map((event: HttpEvent<any>) => {
          let resp: UploadResp = new UploadResp();
          switch (event.type) {
            case HttpEventType.UploadProgress:
              resp.Progress = event.total
                ? Math.round((100 * event.loaded) / event.total)
                : 0;
              resp.Progress = resp.Progress == 100 ? 99 : resp.Progress;
              break;
            case HttpEventType.Response:
              // debugger;
              resp.Obj = event;
              resp.Progress = 100; // Upload completed
              break;
            case HttpEventType.ResponseHeader:
              if (event.status == 401) {
                resp.Obj = event;
                resp.Progress = -1; // Upload completed
              }
              break;
            default:
              resp.Progress = 0;
              break;
          }

          return resp;
        }),
        // 若真的發生網路或伺服器非 200 錯誤，仍由 catchError 處理
        catchError((error: HttpErrorResponse) => {
          const resp = new UploadResp();
          // 如果是 400，直接把 error.error (即 { detail: "..." }) 放進 Obj
          if (error.status === 400) {
            resp.Progress = -1;
            resp.Obj = error.error;  
            // 轉讓 Sync.component.ts 處理
            return of(resp);
          }
          // 其他狀況 (例如 401, 500) 你可選擇重新拋出或回傳特定 resp
          return of(resp);
        })
      );
  }
  //取得資料狀態
  getProjectData(
    pageIndex: number,
    pageSize: number
  ): Observable<FileUploadRoot> {
    let offset = pageSize*(pageIndex - 1);
    const url = `${this.apiBaseUrl}/v1/projects/everything?offset=${offset}&limit=${pageSize}`;
    return this.http.get<FileUploadRoot>(url, this.httpOptions);
  }
  // 驗證伺服器的狀態
  checkService() {
    const url = `${this.apiBaseUrl}/v1/analysis/status`;
    return this.http.get(url, this.httpOptions);
  }
}
